import { Navigate } from 'react-router-dom';
import { isJwtExpired } from '../utils/runtimeConfig';

const AgentProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('ktc_agent_token');

  if (!token) {
    return <Navigate to="/agen/login" replace />;
  }

  if (isJwtExpired(token)) {
    localStorage.removeItem('ktc_agent_token');
    localStorage.removeItem('ktc_agent');
    return <Navigate to="/agen/login" replace />;
  }

  return children;
};

export default AgentProtectedRoute;
